'use client';

import React, { ReactNode } from 'react';
import { cn } from '@ecom/helper-react-class-combine';
import { useCarouselContext } from '../carousel-context';

interface ArrowProps {
  className?: string;
  /** Custom icon. Falls back to a chevron when omitted. */
  children?: ReactNode;
}

const PrevChevron = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={32}
    height={32}
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
    aria-hidden='true'
  >
    <path d='M15 18l-6-6 6-6' />
  </svg>
);

export function CarouselPrevious({ className, children }: ArrowProps): React.ReactElement | null {
  const { canPrev, scrollPrev, slideCount, labels } = useCarouselContext();
  if (slideCount <= 1) return null;
  return (
    <button
      type='button'
      aria-label={labels.prevSlide}
      onClick={scrollPrev}
      disabled={!canPrev}
      className={cn('disabled:pointer-events-none disabled:opacity-40', className)}
    >
      {children ?? PrevChevron}
    </button>
  );
}
